/**
 * The Customer Lounge Collections module ("Go to all collections").
 * Local and QA use the QA lounge; prod also points at QA until the prod lounge
 * collections page exists — safe because `collectionBookmark` is off in prod.
 */
export const LOUNGE_COLLECTIONS_URL =
  "https://qa-customer-lounge.imagio.covestro.com/customer-lounge/collections";

/**
 * `cx-srv-application` behind the CX shell apex (CX-3786), the same host the
 * lounge's `CX_SRV_APPLICATION_URL` points at, with `/application` appended.
 * The service has no production deploy yet (CX-4005); `collectionBookmark` is
 * off in prod until it does.
 */
export const CX_APPLICATION_API_URLS = {
  qa: "https://qa-customer.covestro.com/api/application",
  production: "https://customer.covestro.com/api/application",
} as const;

/** Page size for `GET /v1/collections/membership` — the service's maximum. */
export const MEMBERSHIP_PAGE_LIMIT = 100;

/**
 * Upper bound on membership pages followed per lookup (1,000 collections), so a
 * cursor that never ends can't loop forever.
 */
export const MEMBERSHIP_MAX_PAGES = 10;

/** Page size for `GET /v1/projects/options` — the service's maximum. */
export const PROJECT_OPTIONS_PAGE_LIMIT = 100;

/**
 * Upper bound on project-option pages followed per load. A page can come back
 * short (read-only Projects are dropped after the read) and still carry a cursor.
 */
export const PROJECT_OPTIONS_MAX_PAGES = 20;

/** Saved-state lookups (one per visible result card) allowed in flight at once. */
export const SAVED_STATE_CONCURRENCY = 6;

/** Timeout for every `cx-srv-application` call. */
export const COLLECTIONS_REQUEST_TIMEOUT_MS = 15_000;
